import { useState } from 'react'
import Box from '@mui/material/Box'
import Tabs from './Tabs'
import GetSourceId from './GetSourceId'
import ChangeRealpic from './ChangeRealpic'
import CopyReclip from './CopyReclip'
import AnimatedVideo from './AnimatedVideo'
import DeleteCoverVideo from './DeleteCoverVideo'
import ExportForVeo from './ExportForVeo'

const TABS = [
  {
    type: 'sourceId',
    text: 'Get Source ID',
    description: 'Get the source ID of a reclip from a share link.',
    Component: GetSourceId,
  },
  {
    type: 'realPic',
    text: 'Change Realpic',
    description: 'Change the Realpic on an existing clip.',
    Component: ChangeRealpic,
  },
  {
    type: 'copy',
    text: 'Copy Reclip',
    description: 'Copy a reclip from one library to another.',
    Component: CopyReclip,
  },
  {
    type: 'video',
    text: 'Animated Video',
    description: 'Create an animated video of a clip.',
    Component: AnimatedVideo,
  },
  {
    type: 'exportVeo',
    text: 'Export for Veo',
    description: 'Download audio and view raw transcript for a reclip.',
    Component: ExportForVeo,
  },
  {
    type: 'deleteVideo',
    text: 'Delete Realvid',
    description:
      'Delete the video on a clip, leaving the still realpic in place.',
    Component: DeleteCoverVideo,
  },
]

const Tools = () => {
  const [tab, setTab] = useState(TABS[0].type)
  const curTab = TABS.find((t) => t.type === tab)
  const Component = curTab.Component
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Box sx={{ width: 900, height: '100%', p: 6 }}>
        <Tabs tabs={TABS} tab={curTab} setTab={setTab} />
        <Box sx={{ mt: 2 }}>{curTab.description}</Box>
        <Box sx={{ mt: 4 }}>
          <Component />
        </Box>
      </Box>
    </Box>
  )
}

export default Tools
